<div class="horizontal-page-menu horizontal-page-padding-left">
    <ng-content></ng-content>
</div>